import type { JSX } from 'react'
import { PageLayout } from '#src/components/display/PageLayout.tsx'
import { PhoneCallsTable } from '#src/components/phone-calls/PhoneCallsTable.tsx'
import { useNavigateFromClickEvent } from '#src/hooks/useNavigateFromClickEvent.ts'
import { usePhoneCalls } from '#src/hooks/usePhoneCalls.ts'

export function PhoneCallsPage(): JSX.Element {
  const navigateFromClick = useNavigateFromClickEvent()
  const { data, isLoading, error } = usePhoneCalls()

  return (
    <PageLayout title="Calls">
      <PhoneCallsTable
        onClickRow={(call, event) =>
          navigateFromClick(`/calls/${call.id}`, event)
        }
        data={data}
        isLoading={isLoading}
        error={error}
      />
    </PageLayout>
  )
}
